module.exports = __webpack_public_path__ + "static/media/auditorium.cbef91b4.jpg";